import { render, staticRenderFns } from "./TopJettonItem.vue?vue&type=template&id=5027dc5c"
import script from "./TopJettonItem.vue?vue&type=script&lang=js"
export * from "./TopJettonItem.vue?vue&type=script&lang=js"
import style0 from "./TopJettonItem.vue?vue&type=style&index=0&id=5027dc5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports